 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"16":"defaultVendors~reactPlayerFilePlayer","18":"reactPlayerDailyMotion","19":"reactPlayerFacebook","20":"reactPlayerKaltura","21":"reactPlayerMixcloud","22":"reactPlayerPreview","23":"reactPlayerSoundCloud","24":"reactPlayerStreamable","25":"reactPlayerTwitch","26":"reactPlayerVidyard","27":"reactPlayerVimeo","28":"reactPlayerWistia","29":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"aff4417f5b112ee4038a","1":"54c77b9a3a30dddab18d","2":"208dacc05b081189add7","3":"8a82ec232779685351a8","4":"5326c864d9b36c714a11","5":"71d2ea6077b3618fc3df","6":"6be03eae4bee213e7759","7":"36203b1ad0a0fcbaa7ca","8":"e723d95b287f52c29097","9":"75a8ff656d195c209d42","10":"e160d68f2d902c27e0e5","11":"009f8566125358502e03","12":"9ddb15924990f45a877e","13":"fea1edc84a8d2765660c","14":"4c586d386c3f18d91cc7","16":"174f056fd0d82d3c5f19","18":"ad5bc7ac865f4cafea16","19":"701afb6d8cd10d9162cf","20":"06f6e7f59ce3a5b94cb1","21":"0a04165a93e6c7a2a2c0","22":"a54ff4ff37a05e02fcee","23":"b772dc0db6609fbc3555","24":"3cd864a396541b18d372","25":"8eabd2aa4d4f13092320","26":"0197e73587f69c7c2b44","27":"ec1e0b5ed911032eddea","28":"254c5b533f74a3aa32c2","29":"92e7429355abea60caff","31":"996dd87b2ec2c87504c6","32":"44f8f890a56fd8463349","33":"39b6eacbd7a4e7a31567","34":"475d1c8af3e694dad9a7","35":"260ddbbc38b1b68ca421","36":"a2fb731abc657f6c5495","37":"52840e3b0ba575d07bbd","38":"d653a028b2b435e8566f","39":"538700d51a990a899bda","40":"2fe87e18db81fbd31d2f","41":"384c213683ee6701fc4b","42":"7715c3ce8ed18a0e64a4","43":"049dcef3b3bcc4082729","44":"078274c339e403d95590","45":"8719df0b065c5c1fef3e","46":"21ed056ea2f155e23b72","47":"df76c4ef796e137e32e2","48":"4211bfcd49df7ef780cc","49":"d6431c7d1095a5d963d6","50":"1a5fdeee0bfc5db0f6a7","51":"fadd9f5db3c3c94637f1","52":"e016fcc1df2ce493ff3e","53":"e8e05924bf34e88ebe8a","54":"4119a4c413ba216f24de","55":"597a9c770661da47a885","56":"3069e0501747f93ff45a","57":"c8e73e36c55cfff9ecf9","58":"7a219390fc15f517e9ee","59":"0e1d36b811e37730a026","60":"dda2c55eeaea528a83f4","61":"8995280fdca1e83c5855","62":"4c1cce7a57488a144ba5","63":"79f863f94833de6b3d45","64":"2778e4c182a6b3858a5e","65":"24ba0fa574a686264817","66":"50c6eace5ec96bcdde9c","67":"51e35cde774840b7b19d","68":"21a98101c7d62456b30b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sitefiles/next-gen/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 397);
